import { Component, inject, Input, ViewEncapsulation } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatDialog } from '@angular/material/dialog';
import { ConfirmationDialogComponent } from '../confirmation-dialog/confirmation-dialog.component';
import { OutlineButton } from '../outline-button/outline-button';

@Component({
  selector: 'app-cancel-button',
  imports: [MatButtonModule, OutlineButton],
  templateUrl: './cancel-button.html',
  styleUrl: './cancel-button.scss',
  standalone: true,
  encapsulation: ViewEncapsulation.None,
})
export class CancelButton {
  private _confirmationDialog = inject(MatDialog);

  triggerEvent() {
    const dialogRef = this._confirmationDialog.open(ConfirmationDialogComponent, {
      data: { confirmationMessage: 'Are you sure you want to cancel your registration?' },
    });

    dialogRef.afterClosed().subscribe((result) => {
      if (result) {
        window.location.href = 'https://plusmore.co.za/';
      }
    });
  }
}
